import React from "react";
import {
  defineBlock,
  smartProps,
  EditableDiv,
  EditableImg,
  useEditor,
  useSmartProp,
  useInspectorControl,
} from "@smartfire/gutenberg-react";
import { PanelBody, PanelRow, TextControl } from "@wordpress/components";
import EditableText from "../shared/editable-text";
import style from "./block.module.scss";
import { ReactComponent as Arrow } from "../assets/arrow_right.svg";

function Inspector() {
  const [url, setUrl] = useSmartProp("url");
  const [urlText, setUrlText] = useSmartProp("urlText");
  return (
    <>
      <PanelBody title="Configuration Lien" initialOpen={true}>
        <PanelRow>
          <TextControl
            label={"Lien"}
            value={url}
            onChange={(value) => setUrl(value)}
          />
        </PanelRow>
        <PanelRow>
          <TextControl
            label={"Texte du lien"}
            value={urlText}
            onChange={(value) => setUrlText(value)}
          />
        </PanelRow>
      </PanelBody>
    </>
  );
}

function Block({ title, text, url, urlText, imageRight, imageBottom }) {
  const { isEditing } = useEditor();
  useInspectorControl(Inspector);

  return (
    <div className={style.block}>
      <div className={style.textImgRow}>
        <div className={style.colLeft}>
          <EditableText
            className={style.title}
            tagName="h2"
            smartProp="title"
            placeholder={"Entrez un titre"}
          />
          <div className={style.tiret} />
          <EditableDiv
            className={style.text}
            smartProp="text"
            placeholder={"Entrez un text"}
          />
          {url && (
            <a className={style.link} href={url}>
              {urlText}
              <Arrow />
            </a>
          )}
        </div>
        <div className={style.colRight}>
          <div className={style.imageContainer}>
            {(isEditing || (!isEditing && imageRight)) && (
              <EditableImg smartProp="imageRight" className={style.image} />
            )}
          </div>
        </div>
      </div>
      {/* Si besoin de réutiliser une image bottom
                <div className={style.imageBottomContainer}>
                    {(isEditing || (!isEditing && imageBottom)) &&
                        <EditableImg smartProp="imageBottom" className={style.imageBottom}/>
                    }
                </div>*/}
    </div>
  );
}

export default defineBlock({
  Block,
  smartProps: {
    title: smartProps.string.withDefault(""),
    text: smartProps.string.withDefault(""),
    url: smartProps.string.withDefault(""),
    urlText: smartProps.string.withDefault(""),
    imageRight: smartProps.any.withDefault(""),
    imageBottom: smartProps.any.withDefault(""),
  },
  setup: {
    title: "Texte + Image à droite",
  },
});
